import { Box, TableCell, TableRow } from '@mui/material';
import { FC } from 'react';
import dayjs from 'dayjs';
import TooltipTableCell from '../../../components/formlib/TooltipTableCell';
import { progressRatingsList } from './ChildAndFamilyOutcomes';
import { OutcomeProgress } from '../../../redux/features/ifsp/ifspOutcomesSlice';
import ActionToolTip from '../../../components/formlib/ActionToolTip';
import { ReactComponent as EditIcon } from '../../../assets/images/highlight.svg';
import { ReactComponent as DeleteIcon } from '../../../assets/images/DeleteIcon.svg';
import { useAppSelector } from '../../../redux/hooks';

interface OutcomesProgressInfoTabelRowType {
  data: OutcomeProgress;
  onEdit: (data: OutcomeProgress) => void;
  onDelete: (data: OutcomeProgress) => void;
}

const OutcomeProgressReviewInfoTableRow: FC<
  OutcomesProgressInfoTabelRowType
> = ({ data, onEdit, onDelete }) => {
  const ifspPermission = useAppSelector((state) => state.ifspPermissionDetails);

  return (
    <TableRow>
      <TableCell>
        <TooltipTableCell
          value={data.date ? dayjs(data.date).format('MM/DD/YYYY') : '-'}
          visible={true}
          tooltipSxProps={{
            borderBottom: '0px',
            padding: '0px',
          }}
          textSxProps={{
            maxWidth: '200px',
          }}
        />
      </TableCell>
      <TableCell>
        <TooltipTableCell
          value={data.progressDescription ? data.progressDescription : '-'}
          visible={true}
          tooltipSxProps={{
            borderBottom: '0px',
            padding: '0px',
          }}
          textSxProps={{
            maxWidth: '200px',
          }}
        />
      </TableCell>
      <TableCell>
        <TooltipTableCell
          value={
            progressRatingsList.find((x) => x.id === data.progressRating)
              ?.label ?? '-'
          }
          visible={true}
          tooltipSxProps={{
            borderBottom: '0px',
            padding: '0px',
          }}
          textSxProps={{
            maxWidth: '200px',
          }}
        />
      </TableCell>
      <TableCell className="flex__">
        <Box
          component="div"
          className="pr-sm pt-xs"
          sx={{
            cursor: ifspPermission.hasClientEditPermission
              ? 'pointer'
              : 'not-allowed',
          }}
        >
          <ActionToolTip labelId="BlockTime.edit" defaultLabel="Edit">
            <EditIcon
              onClick={() =>
                ifspPermission.hasClientEditPermission && onEdit(data)
              }
            />
          </ActionToolTip>
        </Box>
        <Box
          component="div"
          className="pr-sm pt-xs"
          sx={{
            cursor: ifspPermission.hasClientEditPermission
              ? 'pointer'
              : 'not-allowed',
          }}
        >
          <ActionToolTip labelId="BlockTime.edit" defaultLabel="Edit">
            <DeleteIcon
              onClick={() =>
                ifspPermission.hasClientEditPermission && onDelete(data)
              }
            />
          </ActionToolTip>
        </Box>
      </TableCell>
    </TableRow>
  );
};

export default OutcomeProgressReviewInfoTableRow;
